// extracted by mini-css-extract-plugin
export default {"pao_mid":"index_pao_mid_V5qmU","box":"index_box_0-dwT","dot":"index_dot_fGwz4","current":"index_current_U4Gjb index_dot_fGwz4"};